<template>
    <div class="section text-center" v-if="loading">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <!-- Reports List - Exact style from Org.vue common_links -->
    <div class="section mt-1" v-if="!loading && reports.length">
        <div class="transactions">
            <a v-for="(report, index) in reports" :key="index" :href="report.link" class="item">
                <div class="detail">
                    <img :src="report.image" alt="report icon" class="image-block imaged w48">
                    <div>
                        <strong class="mal-text">{{ report.title }}</strong>
                        <p class="mal-text">{{ report.desc }}</p>
                    </div>
                </div>
                <div class="right">
                    <div class="price text-primary">
                        <ion-icon name="chevron-forward-outline"></ion-icon>
                    </div>
                </div>
            </a>
        </div>
    </div>

    <!-- Empty State -->
    <div class="section mt-1" v-if="!loading && !reports.length">
        <div class="empty-state">
            <div class="empty-icon">
                <ion-icon name="document-text-outline"></ion-icon>
            </div>
            <h4>No Reports Available</h4>
            <p>You don't have permission to access any reports at this time.</p>
        </div>
    </div>

</template>

<script>
import UserService from "../../services/user.service";

export default {
    name: 'ReportsPage',
    data() {
        return {
            loading: false,
            reports: [],
            permissions: [],
            user_level: "",
            unit_id: "",
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = this.$route.params.sub_level;
            this.unit_id = this.$route.params.id;
            this.getReportsData();
            this.$root.updateParent('Reports Dashboard');
        }
    },
    methods: {
        getReportsData() {
            this.loading = true;
            let data = {
                user_level: this.user_level,
                user_level_id: this.unit_id
            }
            UserService.authGetRequest('get-reports', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.reports = response.data.data.reports || [];
                        this.permissions = response.data.data.permission || [];
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        }
    },
};
</script>

<style scoped>
/* Exact styling from Org.vue for transactions */
.transactions .item {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    padding: 5px 5px;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
    color: inherit;
}

.transactions .item:hover {
    text-decoration: none;
    color: inherit;
}

.detail {
    display: flex;
    align-items: center;
    flex: 1;
}

.image-block {
    margin-right: 15px;
}

.imaged {
    border-radius: 6px;
}

.w48 {
    width: 48px;
    height: 48px;
    object-fit: cover;
}

.detail > div {
    flex: 1;
}

.mal-text {
    color: #333;
}

.detail strong {
    font-size: 14px;
    font-weight: 600;
    display: block;
    margin-bottom: 2px;
}

.detail p {
    font-size: 12px;
    color: #666;
    margin: 0;
    line-height: 1.3;
}

.right {
    display: flex;
    align-items: center;
}

.price {
    font-size: 24px;
    color: #1a418c !important;
}

.text-primary {
    color: #1a418c !important;
}

.empty-state {
    text-align: center;
    padding: 40px 20px;
    color: #666;
}

.empty-icon {
    margin-bottom: 20px;
}

.empty-icon ion-icon {
    font-size: 64px;
    color: #ccc;
}

.empty-state h4 {
    margin-bottom: 10px;
    color: #333;
}

.empty-state p {
    color: #666;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .transactions .item {
        padding: 8px;
    }
    
    .w48 {
        width: 40px;
        height: 40px;
    }
    
    .detail strong {
        font-size: 13px;
    }
    
    .detail p {
        font-size: 11px;
    }
    
    .price {
        font-size: 20px;
    }
}
</style>
